/**
 * Swiper's loop mode clones slides verbatim, so every id inside a product card
 * (quick-add form, its submit button, quick-view modal) appears 2-3 times.
 * getElementById then resolves to whichever copy comes first in the DOM, and
 * label/aria references point at the wrong element.
 *
 * Clones are decoration — they are never the "real" slide — so the safest fix
 * is to strip ids from the duplicates rather than renumber them.
 */
(function () {
  if (window.__onzCloneIdsInit) return;
  window.__onzCloneIdsInit = true;

  function strip(root) {
    (root || document).querySelectorAll('.swiper-slide-duplicate').forEach(function (slide) {
      if (slide.dataset.onzIdsStripped) return;
      slide.dataset.onzIdsStripped = '1';
      slide.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      // for= / aria-controls= now point at nothing; drop them too.
      slide.querySelectorAll('[for], [aria-controls]').forEach(function (el) {
        el.removeAttribute('for');
        el.removeAttribute('aria-controls');
      });
    });
  }

  function run() {
    strip();
    // Swiper clones after init and again on resize/update.
    new MutationObserver(function () { strip(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
